var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRestaurantBudget = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Restaurant-Fork-Spoon--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Restaurant Fork Spoon Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.25 0a1 1 0 0 0 -1 1v5a2 2 0 0 1 -0.57 1.4 0.25 0.25 0 0 1 -0.27 0 0.24 0.24 0 0 1 -0.16 -0.23V1a1 1 0 0 0 -2 0v6.22a0.24 0.24 0 0 1 -0.16 0.23 0.25 0.25 0 0 1 -0.27 0A2 2 0 0 1 5.25 6V1a1 1 0 0 0 -2 0v5a4 4 0 0 0 2.67 3.77 0.5 0.5 0 0 1 0.33 0.47V23a1 1 0 0 0 2 0V10.24a0.5 0.5 0 0 1 0.33 -0.47A4 4 0 0 0 11.25 6V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0a4 4 0 0 0 -4 4v2a4 4 0 0 0 2.67 3.77 0.5 0.5 0 0 1 0.33 0.47V23a1 1 0 0 0 2 0V10.24a0.5 0.5 0 0 1 0.33 -0.47A4 4 0 0 0 20.75 6V4a4 4 0 0 0 -4 -4Zm-0.5 2.5a1 1 0 0 0 -1 1 0.5 0.5 0 0 1 -1 0 2 2 0 0 1 2 -2 0.5 0.5 0 0 1 0 1Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRestaurantBudget);
export default ForwardRef;